import React, { lazy } from 'react';
export function ProductSection() {
  return <section className="w-full py-20 md:py-28 px-6 bg-dark text-center" data-id="element-178">
      <div className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-179">
        <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white mb-6" data-id="element-180">
          El Origen de Tus Bloqueos
        </h2>
        <p className="text-lg md:text-xl text-white/70 font-light mb-16 max-w-2xl leading-relaxed" data-id="element-181">
          Sistema paso a paso para identificar, entender y liberar patrones
          emocionales heredados.
        </p>

        <div className="w-full max-w-4xl mb-16 relative" data-id="element-182">
          <div className="absolute inset-0 bg-terracotta/20 blur-[100px] rounded-full" data-id="element-183"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3oft5g3ztMisBvHzXW6kbP/mockuup.png" alt="Mockup completo del producto con velas" loading="lazy" className="w-full h-auto object-contain relative z-10 drop-shadow-2xl" data-id="element-184" />
        </div>

        <a href="#pricing" className="inline-flex items-center justify-center px-10 py-5 bg-terracotta text-white font-medium text-lg rounded-full hover:bg-terracotta-hover transition-colors duration-300 shadow-lg shadow-terracotta/20" data-id="element-185">
          Ver opciones de acceso →
        </a>
      </div>
    </section>;
}